;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('SnackService', SnackService)

  SnackService.$inject = ['$state', '$rootScope']

  /**
   * Constructor
   */
  function SnackService ($state, $rootScope) {
    var self = this

    /**
     *
     */
    var snacks = []

    //
    _.extend(self, {
      // Public Attributes
      snacks: snacks,

      // Public Methods
      add: add,
      snack: snack
    })

    /**
     * Adds a snack to an array
     * @param options
     */
    function add (options) {
      self.snacks[self.snacks.length] = options
    }

    /**
     * Shows immediately a snack
     * @param options
     */
    function snack (options) {
      $rootScope.$broadcast('snack:add', options)
    }
  }
})(window.angular, window._)
